import { render, staticRenderFns } from "./Switch.vue?vue&type=template&id=5535ebbe&scoped=true&"
import script from "./Switch.vue?vue&type=script&lang=js&"
export * from "./Switch.vue?vue&type=script&lang=js&"
import style0 from "./Switch.vue?vue&type=style&index=0&id=5535ebbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5535ebbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5535ebbe')) {
      api.createRecord('5535ebbe', component.options)
    } else {
      api.reload('5535ebbe', component.options)
    }
    module.hot.accept("./Switch.vue?vue&type=template&id=5535ebbe&scoped=true&", function () {
      api.rerender('5535ebbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/ui/forms/Switch.vue"
export default component.exports